import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Observable, shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScrollButtonDirective } from '../../../../shared/directives/scroll-button/scroll-button.directive';
import { ScrollButtonArrowDirective } from '../../../../shared/directives/scroll-button/scroll-button-arrow.directive';
import { ScrollButtonListDirective } from '../../../../shared/directives/scroll-button/scroll-button-list.directive';
import { MenuListRepository } from '../../../../shared/repositories/menu-list.repository';
import { BreakpointService } from '../../../../shared/services/breakpoint.service';
import { ModalSwipeDirective } from '../../../../shared/directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { PictureFallbackDirective } from '../../../../shared/directives/picture-fallback/picture-fallback.directive';
import { UIMenuCategoryDto } from '../../../../shared/interfaces/ui-menu-category-dto.interface';
import { MenuCategoryDto, MenuItemDto } from 'src/app/api/v1/models';
import { ScrollListService } from 'src/app/services/scroll-list.sevice';
import { TooltipDirective } from "src/app/shared/components/tooltip/tooltip.directive";

@Component({
  selector: 'app-menu-nav',
  templateUrl: './menu-nav.component.html',
  styleUrls: ['./menu-nav.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    NgFor,
    AsyncPipe,
    RouterLink,
    ScrollButtonListDirective,
    ScrollButtonDirective,
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,
    PictureFallbackDirective,
    TooltipDirective
]
})
export class MenuNavComponent {
  constructor(
    private menuRepository: MenuListRepository,
    public breakPoint: BreakpointService,
    private scrollListService: ScrollListService
  ) {}

  isShowModal: boolean = false;
  tooltipMessage = $localize`:@@disabledMenuItemTooltipMessage:We'll open it when the chef says "Done!"`

  @ViewChild(ModalSwipeDirective) modalSwipe: ModalSwipeDirective;

  @Input() menuGroups: UIMenuCategoryDto[];

  activeCategoryIndex$: Observable<number> = this.menuRepository.activeCategoryId$.pipe(
    map(id => {
      for(let i = 0; i < this.menuGroups.length; i++) {
        if(this.menuGroups[i].id === id) {return i;}
      }
      return 0;
    }),
    shareReplay({refCount: true, bufferSize: 1})
  );

  activeCategorySlug$: Observable<string> = this.menuRepository.activeCategory$.pipe(
    map(category => category.slug)
  );
  
  categoryFirstImg$: Observable<any> = this.menuRepository.categories$.pipe(
    map(category => {
      const availableImages: {[key: string]: string} [] = [];

      category?.forEach((category: MenuCategoryDto) => {
        let firstAvailableImg =
          category.items.find((item: MenuItemDto) => Object.keys(item.itemSizes[0].buttonImage).length !== 0);
        firstAvailableImg ? availableImages.push(firstAvailableImg?.itemSizes[0].buttonImage) : availableImages.push({})
      });
      return availableImages;
    })
  );

  setActiveCategory(id: string, index: number): void {
    this.menuRepository.setActiveCategory(id);
    this.menuRepository.setSearchString(null);
    this.isShowModal = false;
    this.scrollListService.setActiveIndex(index);
  }

  onOpenModal(): void {
    this.isShowModal = true;
  }

  onCloseModal(): void {
    this.modalSwipe.hideModal('left');
    setTimeout(() => {
      this.isShowModal = false;
    }, 300);
  }
}
